/* eslint-disable jira/filename-case */
import { REPORTS_IDS } from '@jira/servicedesk__common/src/practicesIds.constants.tsx';

export const connectPrefix = 'com.atlassian.plugins.atlassian-connect-plugin:';
export const jsdConnectPrefix = 'com.atlassian.servicedesk.connect';

const legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const jsdQueuesConnectSection = 'sd-queues-addons';
export const connectSections: readonly [
	'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent',
	'sd-reports-addons',
	'sd-queues-addons',
] = [legacyAddonPanelLinkId, REPORTS_IDS.REPORTS_ADDONS, jsdQueuesConnectSection] as const;
